import { render, staticRenderFns } from "./ModalLayout.vue?vue&type=template&id=36380394&scoped=true&"
import script from "./ModalLayout.vue?vue&type=script&lang=js&"
export * from "./ModalLayout.vue?vue&type=script&lang=js&"
import style0 from "./ModalLayout.vue?vue&type=style&index=0&id=36380394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36380394",
  null
  
)

export default component.exports